<template>
  <crm-side-panel
    @handleClose="handleClose"
    :title="detail.docTitle"
    :elTags="detail.top ? [{ type: 'warning', label: '置顶' }] : []"
  >
    <div class="side-panel-content" v-loading="loading">
      <div class="side-panel-buttons">
        <crm-button
          v-if="auth.knowledgeDocTop && auth.knowledgeDocTop.toggleStatus"
          :size="'mini'"
          :buttonType="'danger'"
          :text="detail.top ? '取消置顶' : '置顶'"
          @click="handleChangeTop()"
        >
        </crm-button>
        <crm-button
          v-if="auth.knowledgeDocUpdate && auth.knowledgeDocUpdate.toggleStatus"
          :size="'mini'"
          :buttonType="'danger'"
          :text="'编辑'"
          @click="handleEdit()"
        >
        </crm-button>
        <crm-button
          v-if="auth.knowledgeDocDelete && auth.knowledgeDocDelete.toggleStatus"
          :size="'mini'"
          :buttonType="'danger'"
          :text="'删除'"
          @click="handleDelete()"
        >
        </crm-button>
      </div>
      <div class="side-panel-header">
        <!-- 头部信息 -->
        <div class="header-info">
          <div class="info-item">
            <p class="info-title">文档目录</p>
            <p class="info-detail">{{ detail.menuName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">阅读量</p>
            <p class="info-detail">{{ detail.readingCount }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">所有者</p>
            <p class="info-detail">{{ detail.modifiedUser }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">更新时间</p>
            <p class="info-detail">{{ detail.modifiedTime }}</p>
          </div>
        </div>
      </div>
      <div class="side-panel-tabs">
        <el-tabs v-model="activeTab" :stretch="false">
          <el-tab-pane label="正文内容" name="info">
            <div
              :unselectable="detail.copy ? 'on' : ''"
              :onselectstart="detail.copy ? false : true"
              :class="[detail.copy ? 'is-no-copy' : '', 'context']"
            >
              <div v-html="detail.context"></div>
              <!-- <el-input :value="detail.context" type="textarea" /> -->
            </div>
          </el-tab-pane>
          <el-tab-pane label="附件" name="file">
            <el-table
              :data="fileList"
              height="calc(100vh - 220px)"
              style="width: 100%"
            >
              <el-table-column prop="fileUrl" label="附件" align="center">
                <template slot-scope="scope">
                  <a
                    v-if="
                      auth.knowledgeDocFile &&
                        auth.knowledgeDocFile.toggleStatus &&
                        scope.row.previewUrl
                    "
                    href="javascript:;"
                    @click="getFildUrl(scope.row)"
                  >
                    {{ scope.row.fileName }}
                  </a>
                  <span v-else>{{ scope.row.fileName || '暂无数据' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="size" label="大小(byte)" align="center">
              </el-table-column>
              <el-table-column width="100" label="操作" align="center">
                <template slot-scope="scope">
                  <a
                    v-if="
                      auth.knowledgeDocFileDownload &&
                        auth.knowledgeDocFileDownload.toggleStatus &&
                        scope.row.fileUrl
                    "
                    :href="scope.row.fileUrl"
                  >
                    下载
                  </a>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="file.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="file.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="fileListTotal.length"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <edit
      :item="docForm.selectedItem"
      :visible="docForm.visible"
      :type="docForm.type"
      @close="docForm.visible = false"
      @success="handleQueryDetail()"
    />
    <el-image-viewer
      v-if="imagePreview.showImage"
      :on-close="closeViewer"
      :url-list="[...imagePreview.url]"
    />
  </crm-side-panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CrmSidePanel from '~component/base/crmSidePanel.vue';
import CrmButton from '@/components/base/crmButton';
import Edit from '@/components/business/knowledge/addDocument.vue';

export default {
  props: {
    id: String,
    cuttentItem: Object,
    visible: Boolean,
  },
  components: {
    CrmSidePanel,
    CrmButton,
    Edit,
    'el-image-viewer': () =>
      import('element-ui/packages/image/src/image-viewer'),
  },
  data() {
    return {
      loading: true,
      fileList: [],
      fileListTotal: [],
      activeTab: 'info',
      elTags: [],
      top: ['是否置顶?', '取消置顶?'],
      file: {
        pageNumber: 1,
        pageSize: 10,
      },
      docForm: {
        type: 'add',
        visible: false,
        selectItem: {},
        id: '',
      },
      imagePreview: {
        showImage: false,
        url: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      detail: 'knowledge/detail',
    }),
  },
  watch: {
    id(val) {
      if (val) {
        this.id = val;
      }
    },
  },
  mounted() {
    this.handleQueryDetail(this.id, 1);
  },
  methods: {
    ...mapActions({
      deleteClue: 'clue/deleteClue',
      getKnowDetail: 'knowledge/getKnowDetail',
      getKnowTeam: 'knowledge/getKnowTeam',
      toTop: 'knowledge/toTop',
      deleteKnowDoc: 'knowledge/deleteKnowDoc',
    }),
    handleQueryDetail(id = this.id, viewFlag) {
      this.loading = true;
      this.getKnowDetail({ id, viewFlag }).finally(() => {
        this.fileList = this.detail.fileList;
        this.fileListTotal = this.detail.fileList;

        this.loading = false;
        this.handleChangeFile();
      });
    },
    handleEditSuccess() {
      this.handleQueryDetail({ id: this.id });
      this.$emit('refresh');
    },
    handleEdit() {
      this.docForm.type = 'edit';
      this.docForm.visible = true;
      this.docForm.selectedItem = this.detail;
    },
    handleDelete() {
      this.$confirm('此操作将永久删除该文档, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteKnowDoc({ id: this.id })
            .then(() => {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.$emit('close');
              this.$emit('refresh');
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    handleChangeTop() {
      this.$confirm(this.top[this.detail.top], '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.toTop({ id: this.detail.id }).then(() => {
          this.handleQueryDetail(this.detail.id);
        });
      });
    },
    handleClose() {
      this.activeTab = 'info';
      this.$emit('close');
      this.$emit('refresh');
    },
    toCustomDetail() {
      if (this.detail.customerIsDeleted) {
        this.$message.error('该客户已被删除');
      } else {
        this.customDetailShow = true;
        this.viewPanel = {
          uid: this.detail.customerId,
          authEdit: this.webCustomerAuth.update.auth,
          authDelete: this.webCustomerAuth.delete.auth,
        };
      }
    },
    handleSizeChange(val) {
      this.file.pageSize = val;
      this.file.pageNumber = 1;

      this.handleChangeFile();
    },
    handleCurrentChange(val) {
      this.file.pageNumber = val;
      this.handleChangeFile();
    },
    handleChangeFile() {
      const pageNumber = this.file.pageNumber;
      const pageSize = this.file.pageSize;
      const start = (pageNumber - 1) * pageSize;
      const end = pageNumber * pageSize;
      this.fileList = this.detail.fileList.slice(start, end);
    },
    htmlDecodeByRegExp(str) {
      var s = '';
      if (str.length === 0) return '';
      s = str.replace(/&amp;/g, '&');
      s = s.replace(/&lt;/g, '<');
      s = s.replace(/&gt;/g, '>');
      s = s.replace(/&nbsp;/g, ' ');
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', m, { passive: false }); // 禁止页面滑动
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = 'auto'; // 出现滚动条
      document.removeEventListener('touchmove', m, { passive: true });
    },
    getFildUrl(row) {
      this.imagePreview.url = '';
      const typeArr = row.fileName.split('.');
      if (['png', 'jpg', 'jpeg'].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === 'pdf') {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
  },
};
</script>

<style lang="less">
.context {
  p,
  span,
  h1 ~ h6,
  div {
    height: 28px;
    line-height: 28px;
  }
}
.is-no-copy {
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.el-dropdown-menu .el-dropdown-menu__item {
  cursor: pointer;
}
</style>
